






import { Component, Vue, Prop } from 'vue-property-decorator'
import { tenant } from '@tenant/config'

import Header from '@/components/Header.vue'
import Page from '@/components/Page.vue'

@Component<DeleteAccountView>({
  components: {
    Header,
    Page
  },
})
export default class DeleteAccountView extends Vue {
  get mailto(): string {
    return 'mailto:fiftyfifty@apprime.biz?subject=' + encodeURIComponent(tenant.deleteAccountMailSubject)
  }
}
